import React from 'react';
import { IDealer } from 'next-common';
import { Icon, IconType } from '@repo/ui/components';
import { cn } from 'types';

export interface IDealerOptionProps {
  dealer: IDealer;
  selected: boolean;

  handleSelect(): void;
}

export const DealerOption = (props: IDealerOptionProps) => (
  <button
    onClick={props.handleSelect}
    className={cn('grid grid-cols-[auto_1.5rem] cursor-pointer py-[2px] px-3', props.selected ? 'bg-lightGrey' : '')}
  >
    <div className="text-base/[175%] font-bold text-left">{props.dealer.dealerId}</div>
    <div className="flex justify-center items-center">
      {props.selected && (
        <span className="size-[1.25rem] rounded-full bg-indigo relative flex justify-center items-center">
          <Icon icon={IconType.NewNextCheck} fill="var(--color-white)" width={24} height={24} />
        </span>
      )}
    </div>
  </button>
);
